import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/static/illustrations/astronaut.png'


const _withScopeId = n => (_pushScopeId("data-v-19ac80f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Astronauta",
      class: "astronaut-image"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Avaliação finalizada com Sucesso!"),
      /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Agradecemos sua participação!")
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}